import "core-js/modules/es.array.concat";
import "core-js/modules/es.function.name";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
export var setCookie = function setCookie(_ref) {
  var name = _ref.name,
      value = _ref.value,
      days = _ref.days,
      _ref$path = _ref.path,
      path = _ref$path === void 0 ? '/' : _ref$path,
      _ref$session = _ref.session,
      session = _ref$session === void 0 ? false : _ref$session;
  var expires = '';

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=".concat(date.toUTCString());
  }

  document.cookie = "".concat(name, "=").concat(value).concat(session ? '' : expires, "; path=").concat(path);
};
export var getCookie = function getCookie(_ref2) {
  var name = _ref2.name;
  var value = "; ".concat(document.cookie);
  var parts = value.split("; ".concat(name, "="));

  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }

  return undefined;
};
export var deleteCookie = function deleteCookie(_ref3) {
  var name = _ref3.name;
  return setCookie({
    name: name,
    value: '',
    days: -1
  });
};